import Button from '../../../components/common/Button';
import ImageUploader from '../../../components/common/Form/ImageUploader';

interface RestaurantLogoImagePageProps {
  logoImage: Blob | string | null;
  handleLogoImageUpload: (file: Blob) => void;
  onNext: () => void;
  onBack: () => void;
}

const RestaurantLogoPhotoPage = ({
  logoImage,
  handleLogoImageUpload,
  onNext,
  onBack
}: RestaurantLogoImagePageProps) => (
  <div className="restaurant-photo-page restaurant-logo-page">
    <div className="restaurant-wizard-logo-image-container">
      <h2 className="restaurant-wizard-section-heading">RESTAURANT LOGO</h2>
      <p className="restaurant-wizard-image-copy">
        Upload your restaurant&apos;s logo to be used on your QR code.{' '}
        <i>Please note that higher resolution files are more likely to display more clearly.</i>
      </p>
      <ImageUploader id="0" image={logoImage} onUpdate={(file: Blob) => handleLogoImageUpload(file)} />
    </div>
    <div className="restaurant-wizard-photo-buttons">
      <Button className="restaurant-wizard-back-button" onClick={onBack}>
        BACK
      </Button>
      <Button className="restaurant-wizard-next-button" onClick={onNext}>
        NEXT
      </Button>
    </div>
  </div>
);

export default RestaurantLogoPhotoPage;
